"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.payloadSchema = exports.Payload = void 0;
class Payload {
    constructor(data) {
        this.tag = 2147484061;
        this.message = data.message;
        this.nonce = data.nonce;
        this.recipient = data.recipient;
        if (data.callbackUrl) {
            this.callbackUrl = data.callbackUrl;
        }
    }
}
exports.Payload = Payload;
exports.payloadSchema = new Map([
    [
        Payload,
        {
            kind: "struct",
            fields: [
                ["tag", "u32"],
                ["message", "string"],
                ["nonce", [32]],
                ["recipient", "string"],
                [
                    "callbackUrl",
                    {
                        kind: "option",
                        type: "string",
                    },
                ],
            ],
        },
    ],
]);
